module.exports = __webpack_public_path__ + "static/media/black.d9eee09d.svg";